import React from "react";
import styles from "./error-pane.module.scss";
import { HintTitle } from "@components/atoms/hint-title/hint-title";
import { Title } from "@components/atoms/title/title";
import { ButtonWithIcon } from "@components/atoms/buttons/button-with-icon/button-with-icon";
import ServerErrorImg from "./server-error.png";
import RefreshIconOneArrow from "@src/assets/svg/refresh-one-arrow.svg";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";

interface ErrorPanePropTypes {
  hintTitleText: string;
  titleText: string;
  buttonText?: string;
  showTitleFirst?: boolean;
}

const cssClassName = "error-pane";

export const ErrorPane = ({
  hintTitleText,
  titleText,
  buttonText,
  showTitleFirst = false,
}: ErrorPanePropTypes) => {
  const refresh = () => {
    navigateTo(Route.MACHINES);
  };

  return (
    <div className={styles[cssClassName]}>
      <div
        className={
          showTitleFirst
            ? styles[`${cssClassName}__permission-titles-wrapper`]
            : styles[`${cssClassName}__titles-wrapper`]
        }
      >
        {showTitleFirst ? <Title text={titleText} /> : null}
        <HintTitle text={hintTitleText} />
        {!showTitleFirst ? <Title text={titleText} /> : null}
      </div>
      <img src={ServerErrorImg} alt="Server Error" />
      {buttonText ? (
        <div className={styles[`${cssClassName}__button-wrapper`]}>
          <ButtonWithIcon
            fun={() => refresh()}
            text={buttonText}
            icon={RefreshIconOneArrow}
          />
        </div>
      ) : null}
    </div>
  );
};
